import FontFaceObserver from 'fontfaceobserver'

const fontURLs = [
    {
        name: 'Nunito Sans',
        url: 'https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@200;300;400;600;700&display=swap',
    },
    {
        name: 'IBM Plex Sans',
        url: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&display=swap',
    },
    {
        name: 'IBM Plex Mono',
        url: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@500&display=swap',
    },
    {
        name: 'Raleway',
        url: 'https://fonts.googleapis.com/css2?family=Raleway:wght@900&display=swap',
    },
]

const Fonts = async () => {
    for (const font of fontURLs) {
        const link = document.createElement('link')
        link.href = font.url
        link.rel = 'stylesheet'

        document.head.appendChild(link)

        const ffo = new FontFaceObserver(font.name)
        await ffo.load()
    }
}

export default Fonts
